<!-- 第一种登录方式 -->
<template>
  <div class="first-wrap">
    <el-form
      :model="ruleForm2"
      :rules="rules2"
      ref="ruleForm2"
      label-position="left"
      label-width="0px"
      class="demo-ruleForm login-container"
    >
      <el-form-item prop="account">
        <el-input
          type="text"
          prefix-icon="el-icon-user"
          v-model="ruleForm2.account"
          auto-complete="off"
          placeholder="账号/身份证"
        ></el-input>
      </el-form-item>
      <el-form-item prop="checkPass" style="margin-bottom: 0;">
        <!-- @keyup.enter.native回车触发登录按钮 -->
        <el-input
          prefix-icon="el-icon-unlock"
          v-model="ruleForm2.checkPass"
          auto-complete="off"
          show-password
          placeholder="密码"
          @keyup.enter.native="handleSubmit2"
        ></el-input>
      </el-form-item>
      <div class="option-box">
        <!-- <el-checkbox v-model="checked" checked class="remember">记住密码</el-checkbox> -->
        <router-link to="/" tag="div" class="link">找回密码</router-link>
        <!-- <router-link to="/" tag="div" class="link">立即注册</router-link> -->
      </div>
      <el-form-item style="width:100%;">
        <el-button
          type="primary"
          style="width:100%;margin-top:20px"
          @click.native.prevent="handleSubmit2"
          :loading="logining"
        >{{loginStr}}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      innerVisibleTotal: false,
      instance: '',
      loginStr: '登录',
      logining: false,
      ruleForm2: {
        account: null,
        checkPass: null,
      },
      rules2: {
        account: [
          {
            required: true,
            message: '请输入账号或者是身份证',
            trigger: 'blur',
          },
        ],
        checkPass: [{ required: true, message: '请输入密码', trigger: 'blur' }],
      },
      checked: true,
    };
  },
  //方法集合
  methods: {
    // 获取 Token
    handleSubmit2(ev) {
      var _this = this;
      _this.$refs.ruleForm2.validate((valid) => {
        if (valid) {
          _this.logining = true;

          let loginForm = {
            name: _this.ruleForm2.account,
            pass: _this.ruleForm2.checkPass,
          };
          _this.$store
            .dispatch('Login', loginForm)
            .then((res) => {
              _this.logining = false;
              console.log(res);
              // _this.$router.push({ name: 'dashboard' });

              _this.$emit('closeAlert', false); //登录弹窗关闭

              // 重要！跟读取cookie用户信息有关
              // location.reload();
            })
            .catch(() => {
              _this.logining = false;
            });
        } else {
          console.log('error submit!!');

          return false;
        }
      });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
};
</script>
<style scoped>
/deep/ .login-container {
  width: 70%;
  margin: 0 auto;
}
/deep/ .el-input__inner::placeholder {
  font-size: 14px !important;
}
/deep/.el-input__prefix {
  font-size: 16px !important;
}
</style>
<style lang='scss' scoped>
.first-wrap {
  .option-box {
    width: 100%;
    // display: flex;
    margin-bottom: 20px;
    // justify-content: right;
    color: #1492ff;
    .remember {
      flex: 1;
      overflow: hidden;
    }

    .link {
      // width: 20%;
      // padding: 0 10px;
      text-align: right;
      cursor: pointer;
      float: right;
      // &:hover {
      //   transform: scale(1.1);
      //   @include themeify {
      //     color: themed('color-text-primary');
      //   }
      // }
    }
  }

  .login-foot {
    display: flex;
    align-items: center;
    padding-bottom: 30px;

    .icon {
      margin: 0 10px;
      &:hover {
        transform: scale(1.1);
      }
    }
  }
}
</style>